import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
	dateType: string = 'MMM dd, yyyy HH:mm';
	toDate: string = 'MMM dd, yyyy';
	toDateTime_ss: string = 'MMM dd, yyyy HH:mm:ss';
}